module.exports = __webpack_public_path__ + "img/1f93f.cdcc48a.svg";